export default function CompanyOverview() {
  return (
    <section id="about" className="bg-[#F8F8F8] py-32">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="max-w-[900px] mx-auto text-center">
          <h2 className="font-serif text-[42px] text-black mb-5">会社概要</h2>
          <div className="w-20 h-px bg-[#2C2C2C] mx-auto mb-16" />
          
          <div className="space-y-6 text-[16px] text-[#2C2C2C] leading-[1.9]">
            <p>
              私たちは、バケーションレンタル市場における不動産仲介のリーディングカンパニーとして、
              オーナー様と利用者様の双方に最適なソリューションを提供しております。
              長年培ってきた専門知識と豊富な実績により、安心してお任せいただける体制を整えております。
            </p>
            <p>
              物件の選定から契約、運用管理まで、一貫したサポート体制でお客様のニーズにお応えします。
              市場動向の分析、適正価格の設定、効果的なマーケティング戦略の立案など、
              プロフェッショナルとしての視点から最適なご提案をいたします。
            </p>
            <p>
              お客様との信頼関係を何よりも大切にし、透明性の高い取引と丁寧なコミュニケーションを心がけております。
              バケーションレンタル事業の成功に向けて、私たちが全力でサポートいたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
